import gql from 'graphql-tag';
import * as i0 from "@angular/core";
import * as i1 from "../shared/services/graph-qlclient.service";
export class RegionService {
    constructor(gqlclient) {
        this.gqlclient = gqlclient;
    }
    obtenerRegionSegunCodigo(inputParams, callback) {
        this.gqlclient.query({
            query: gql `
        query ($entidad: regionInputType) {
          region {
            obtenerRegionSegunCodigo(entidad: $entidad) {
              mensajes {
                codigo
                texto
                tipo
              }
              respuesta {
                registros {
                  codigo
                  nombre
                }
              }
            }
          }
        }
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.region.obtenerRegionSegunCodigo;
            callback({ mensajes, respuesta });
        });
    }
}
RegionService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function RegionService_Factory() { return new RegionService(i0.ɵɵinject(i1.GraphQLClient)); }, token: RegionService, providedIn: "root" });
